import {createElement, Component, PropTypes} from 'rlink-react';

export default class CSSScaleContentGroup extends Component {
  getResolution () {
    let scale = window.innerHeight / 1094;
    return {
      'transform': `translateZ(0) translateX(-50%) scale(${scale})`,
      '-webkit-transform': `translateZ(0) translateX(-50%) scale(${scale})`,
      'transform-origin': 'top',
      '-webkit-transform-origin': 'top',
      'height': `${window.innerHeight / scale}px`,
      'position': 'absolute',
      'left': '50%',
    };
  }
  updateDimensions () {
    this.forceUpdate();
  }

  componentDidMount () {
    this.boundUpdateDimensions = this.updateDimensions.bind(this);
    window.addEventListener('resize', this.boundUpdateDimensions);
  }
  componentWillUnmount () {
    window.removeEventListener('resize', this.boundUpdateDimensions);
  }

  render () {
    return (<div style={this.getResolution()}>
      {this.props.children}
    </div>);
  }
}

CSSScaleContentGroup.propTypes = {
  children: PropTypes.node,
};



// WEBPACK FOOTER //
// ./lib/rlink-layout/components/CSSScaleContentGroup.jsx